import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Transition from 'react-transition-group/Transition'
import { pixelise } from 'tools/style'
import WindowEvents from 'decorators/WindowEvents'
import Div from 'components/Div'

const Container = styled(Div)`
  overflow: hidden;
  height: auto;
  max-height: ${props => props.maxHeight ? pixelise(props.maxHeight) : (props.minHeight ? pixelise(props.minHeight) : 0)};
  ${props => props.minHeight ? `min-height: ${pixelise(props.minHeight)};` : ''}
  transition: max-height ${props => props.transitionDuration}ms ease-in-out;
`

class Collapsible extends React.PureComponent {
  static propTypes = {
    id: PropTypes.string,
    show: PropTypes.bool,
    transitionDuration: PropTypes.number, // in ms
    minHeight: PropTypes.number,
    mountOnEnter: PropTypes.bool,
    unmountOnExit: PropTypes.bool,
    registerEventListener: PropTypes.func.isRequired // Injected by WindowEvents
  }

  static defaultProps = {
    show: false,
    transitionDuration: 500,
    mountOnEnter: false,
    unmountOnExit: false
  }

  constructor (props) {
    super(props)
    this.state = {
      maxHeight: props.show ? 'initial' : 0
    }
    props.registerEventListener('resize', this.computeHeight, false)
  }

  componentDidUpdate (prevProps) {
    prevProps.show !== this.props.show && this.computeHeight()
  }

  computeHeight = () => this.props.show ? this.setHeight() : this.setHeight(() => setTimeout(this.resetHeight, 0))

  setHeight = (callback = () => {}) => {
    if (!this._container) return
    const height = this._container.getBoundingClientRect().height
    this.setState({ maxHeight: height }, callback)
  }

  resetHeight = () => this.setState({ maxHeight: 0 })

  onEntered = () => this.props.show && this.setState({ maxHeight: 'initial' })

  render () {
    const { id, children, className, transitionDuration, minHeight, show, mountOnEnter, unmountOnExit } = this.props
    const { maxHeight } = this.state

    return (
      <Container id={id} className={className} maxHeight={maxHeight} show={show} transitionDuration={transitionDuration} onTransitionEnd={this.onEntered} minHeight={minHeight}>
        <Div ref={(e) => { this._container = e }}>
          <Transition in={show} timeout={transitionDuration} mountOnEnter={mountOnEnter} unmountOnExit={unmountOnExit}>
            <React.Fragment>{children}</React.Fragment>
          </Transition>
        </Div>
      </Container>
    )
  }
}

export default WindowEvents(Collapsible)
